/** @format */

export const generalGetAuth = (data) => ({ type: 'AUTH_GET', data });

export const generalSetAuth = (auth) => ({
  type: 'AUTH_SET',
  auth,
});

export const fetchAuth = (data) => ({ type: 'AUTH_FETCH', data });

export const resetAuth = (data) => ({ type: 'AUTH_RESET', data });
